import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetMedcDetails = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_MEDC_DETAILS, token);
  return res;
};

export const GetMedcDetailsByID = async (medcInflId) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_MEDC_DETAILS_BY_ID, token);
  return res;
};

export const AddMedcInfl = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_MEDC, payload, token);
  return res;
};

export const DeleteMedcInfl = async (medcInflId) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(
    Url.DELETE_MEDC + medcInflId,
    medcInflId,
    token
  );
  return res;
};

export const UpdateMedcInfl = async (medcinflId, payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.UPDATE_MEDC + medcinflId, payload, token);
  return res;
};
